
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { DesktopNav } from "./navigation/DesktopNav";

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  const mobileLinkClass = "block w-full text-left px-4 py-3 text-foreground hover:bg-primary/15 hover:text-primary transition-colors";

  const showSolid = isScrolled || isMobileMenuOpen;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      showSolid
        ? 'bg-background border-b border-border shadow-sm' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <button 
              onClick={scrollToTop}
              className={`text-2xl font-normal cursor-pointer transition-colors ${
                showSolid ? 'text-foreground hover:text-primary' : 'text-primary-foreground hover:text-primary'
              }`}
            >
              auryx
            </button>
          </div>

          <DesktopNav scrollToContact={scrollToContact} isScrolled={isScrolled} />

          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={handleMobileMenuToggle}
              className={showSolid ? 'text-foreground hover:text-primary' : 'text-primary-foreground hover:text-primary'}
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

      </div>
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-background border-t border-border shadow-lg">
          <div className="flex flex-col py-3">
            <button 
              onClick={() => {
                handleMobileNavClick();
                document.getElementById('tech')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={mobileLinkClass}
            >
              Technology
            </button>
            <button 
              onClick={() => {
                handleMobileNavClick();
                document.getElementById('research')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={mobileLinkClass}
            >
              Research
            </button>
            <button 
              onClick={() => {
                handleMobileNavClick();
                document.getElementById('team')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={mobileLinkClass}
            >
              Team
            </button>
            <button 
              onClick={() => {
                handleMobileNavClick();
                document.getElementById('careers')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={mobileLinkClass}
            >
              Careers
            </button>
            <a 
              href="#contact"
              onClick={handleMobileNavClick}
              className={mobileLinkClass}
            >
              Contact
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
